var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-weight": "600",
                  "margin-right": "20px",
                  "font-size": "14px",
                },
              },
              [_vm._v(_vm._s(_vm.$t("panel.component_style")))]
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-row",
        {
          staticClass: "main-content",
          attrs: { disabled: "!curComponent.commonBackground.enable" },
        },
        [
          _c(
            "el-row",
            { staticStyle: { height: "50px", overflow: "hidden" } },
            [
              _c("el-col", { attrs: { span: 3 } }, [
                _c("span", { staticClass: "params-title" }, [
                  _vm._v(_vm._s(_vm.$t("panel.inner_padding"))),
                ]),
              ]),
              _c(
                "el-col",
                { attrs: { span: 15 } },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      max: 50,
                    },
                    model: {
                      value: _vm.curComponent.commonBackground.innerPadding,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.curComponent.commonBackground,
                          "innerPadding",
                          $$v
                        )
                      },
                      expression: "curComponent.commonBackground.innerPadding",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { height: "50px", overflow: "hidden" } },
            [
              _c("el-col", { attrs: { span: 3 } }, [
                _c("span", { staticClass: "params-title" }, [
                  _vm._v(_vm._s(_vm.$t("panel.board_radio"))),
                ]),
              ]),
              _c(
                "el-col",
                { attrs: { span: 15 } },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                    },
                    model: {
                      value: _vm.curComponent.commonBackground.borderRadius,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.curComponent.commonBackground,
                          "borderRadius",
                          $$v
                        )
                      },
                      expression: "curComponent.commonBackground.borderRadius",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { height: "40px", overflow: "hidden" } },
            [
              _c(
                "el-col",
                {
                  staticStyle: { "padding-left": "10px", "padding-top": "5px" },
                  attrs: { span: 3 },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value:
                          _vm.curComponent.commonBackground
                            .backgroundColorSelect,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.curComponent.commonBackground,
                            "backgroundColorSelect",
                            $$v
                          )
                        },
                        expression:
                          "curComponent.commonBackground.backgroundColorSelect",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.color")))]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { staticStyle: { "padding-top": "5px" }, attrs: { span: 1 } },
                [
                  _c("el-color-picker", {
                    staticClass: "color-picker-style",
                    attrs: {
                      disabled:
                        !_vm.curComponent.commonBackground
                          .backgroundColorSelect,
                      size: "mini",
                      predefine: _vm.predefineColors,
                    },
                    model: {
                      value: _vm.curComponent.commonBackground.color,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.curComponent.commonBackground,
                          "color",
                          $$v
                        )
                      },
                      expression: "curComponent.commonBackground.color",
                    },
                  }),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 3 } }, [
                _c("span", { staticClass: "params-title-small" }, [
                  _vm._v(_vm._s(_vm.$t("chart.not_alpha"))),
                ]),
              ]),
              _c(
                "el-col",
                { attrs: { span: 11 } },
                [
                  _c("el-slider", {
                    attrs: {
                      disabled:
                        !_vm.curComponent.commonBackground
                          .backgroundColorSelect,
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                    },
                    model: {
                      value: _vm.curComponent.commonBackground.alpha,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.curComponent.commonBackground,
                          "alpha",
                          $$v
                        )
                      },
                      expression: "curComponent.commonBackground.alpha",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { height: "50px" } },
            [
              _c(
                "el-col",
                {
                  staticStyle: { "padding-left": "10px", "padding-top": "5px" },
                  attrs: { span: 3 },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.curComponent.commonBackground.enable,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.curComponent.commonBackground,
                            "enable",
                            $$v
                          )
                        },
                        expression: "curComponent.commonBackground.enable",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("panel.background")))]
                  ),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 21 } }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      color: "#909399",
                      "font-size": "8px",
                      "margin-left": "3px",
                      "line-height": "30px",
                    },
                  },
                  [
                    _vm._v(
                      "\n          Tips:" +
                        _vm._s(_vm.$t("panel.choose_background_tips")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _vm.curComponent.commonBackground.enable
            ? _c(
                "el-row",
                { staticStyle: { "padding-left": "10px" } },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        height: "80px",
                        "margin-top": "0px",
                        "margin-bottom": "20px",
                        overflow: "hidden",
                      },
                    },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-left": "10px" },
                          attrs: { span: 4 },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "outerImage" },
                              on: { change: _vm.onChangeType },
                              model: {
                                value:
                                  _vm.curComponent.commonBackground
                                    .backgroundType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.curComponent.commonBackground,
                                    "backgroundType",
                                    $$v
                                  )
                                },
                                expression:
                                  "curComponent.commonBackground.backgroundType",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("panel.photo")) + "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticStyle: { width: "130px!important" } },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              class: { disabled: _vm.uploadDisabled },
                              attrs: {
                                action: "",
                                accept: ".jpeg,.jpg,.png,.gif,.svg",
                                "list-type": "picture-card",
                                "on-preview": _vm.handlePictureCardPreview,
                                "on-remove": _vm.handleRemove,
                                "http-request": _vm.upload,
                                "file-list": _vm.fileList,
                              },
                            },
                            [_c("i", { staticClass: "el-icon-plus" })]
                          ),
                          _c(
                            "el-dialog",
                            {
                              attrs: {
                                top: "25vh",
                                width: "600px",
                                "append-to-body": true,
                                "destroy-on-close": true,
                                visible: _vm.dialogVisible,
                              },
                              on: {
                                "update:visible": function ($event) {
                                  _vm.dialogVisible = $event
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "100%",
                                  src: _vm.dialogImageUrl,
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            "padding-left": "10px",
                            position: "relative",
                          },
                          attrs: { span: 4 },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "innerImage" },
                              on: { change: _vm.onChangeType },
                              model: {
                                value:
                                  _vm.curComponent.commonBackground
                                    .backgroundType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.curComponent.commonBackground,
                                    "backgroundType",
                                    $$v
                                  )
                                },
                                expression:
                                  "curComponent.commonBackground.backgroundType",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("panel.board")) + "\n          "
                              ),
                            ]
                          ),
                          _c("el-color-picker", {
                            staticClass: "color-picker-style",
                            staticStyle: {
                              position: "absolute",
                              right: "15px",
                              top: "-3px",
                            },
                            attrs: {
                              title: "边框配色",
                              size: "mini",
                              predefine: _vm.predefineColors,
                            },
                            model: {
                              value:
                                _vm.curComponent.commonBackground
                                  .innerImageColor,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.curComponent.commonBackground,
                                  "innerImageColor",
                                  $$v
                                )
                              },
                              expression:
                                "curComponent.commonBackground.innerImageColor",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticClass: "main-row",
                          style: _vm.customStyle,
                          attrs: { span: 20 },
                        },
                        _vm._l(_vm.BackgroundShowMap, function (value, key) {
                          return _c(
                            "el-row",
                            { key: key },
                            _vm._l(value, function (item) {
                              return _c(
                                "el-col",
                                { key: item.id, attrs: { span: 6 } },
                                [
                                  _c("background-item", {
                                    attrs: { template: item },
                                  }),
                                ],
                                1
                              )
                            }),
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isFilterComponent
            ? _c(
                "el-row",
                { staticStyle: { height: "40px", overflow: "hidden" } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        "padding-left": "10px",
                        "padding-top": "8px",
                      },
                      attrs: { span: 5 },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("panel.input_style")) +
                          ":\n      "
                      ),
                    ]
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        "padding-left": "10px",
                        "padding-top": "8px",
                      },
                      attrs: { span: 2 },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("panel.board")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "padding-top": "5px" },
                      attrs: { span: 3 },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { size: "mini", predefine: _vm.predefineColors },
                        model: {
                          value: _vm.curComponent.style.brColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.curComponent.style, "brColor", $$v)
                          },
                          expression: "curComponent.style.brColor",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        "padding-left": "10px",
                        "padding-top": "8px",
                      },
                      attrs: { span: 2 },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t("panel.text")) + "\n      "
                      ),
                    ]
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "padding-top": "5px" },
                      attrs: { span: 3 },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { size: "mini", predefine: _vm.predefineColors },
                        model: {
                          value: _vm.curComponent.style.wordColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.curComponent.style, "wordColor", $$v)
                          },
                          expression: "curComponent.style.wordColor",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        "padding-left": "10px",
                        "padding-top": "8px",
                      },
                      attrs: { span: 2 },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("panel.background")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "padding-top": "5px" },
                      attrs: { span: 3 },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { size: "mini", predefine: _vm.predefineColors },
                        model: {
                          value: _vm.curComponent.style.innerBgColor,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.curComponent.style,
                              "innerBgColor",
                              $$v
                            )
                          },
                          expression: "curComponent.style.innerBgColor",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "root-class" },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("commons.cancel")) + "\n      ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("commons.confirm")) + "\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }